module.exports = "pegasus/assets/frame-large-twitter-old.png";